import { Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import { Box } from '@mui/material';
import { useState } from 'react';
import Compose from './pages/Compose';
import RecipeDetail from './pages/RecipeDetail';
import SavdRecipe from './pages/SavedRecipes';
import Footer from './components/Footer';

function App() {
  const [token, setToken] = useState();
  return (
    <Box>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/compose" element={<Compose />}></Route>
        <Route path="/recipe/:id" element={<RecipeDetail />}></Route>
        <Route
          path="/recipes/savedRecipes/:id"
          element={<SavdRecipe />}
        ></Route>
      </Routes>
      <Footer />
    </Box>
  );
}

export default App;
